import { render, staticRenderFns } from "./Customlist.vue?vue&type=template&id=790fea2c&scoped=true&"
import script from "./Customlist.vue?vue&type=script&lang=js&"
export * from "./Customlist.vue?vue&type=script&lang=js&"
import style0 from "./Customlist.vue?vue&type=style&index=0&id=790fea2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790fea2c",
  null
  
)

export default component.exports